@if (isShowControls) {
  <div class="list-page-header">
    <div class="list-filters">
      <button type="button" class="table-header-filter-btn" (click)="filterMenu.toggle($event)" #filterBtn>
        <rkt-icon name="filter" class="table-header-filter-icon"></rkt-icon>
        Filter
        @if (activeFiltersCount) {
          <span class="table-header-filter-counter">{{ activeFiltersCount }}</span>
        }
      </button>
      <app-filter-menu
        #filterMenu
        [initialValues]="activeFilters"
        [filters]="filters"
        (opened)="filterBtn.classList.add('opened')"
        (closed)="filterBtn.classList.remove('opened')"
        (saved)="applyFilters($event)"
      ></app-filter-menu>
    </div>
    <div class="list-page-controls">
      @if (createIntegratedFaFlag$ | async) {
        <app-add-financial-account-method-select
          [disabled]="!!(loading | accessControl | async)"
          (onboardAccountMethod)="onboardAccountMethod($event)"
        ></app-add-financial-account-method-select>
      }
    </div>
  </div>
}

<rkt-table
  [rows]="financialAccounts"
  [columns]="columns"
  [limit]="10"
  (fetchData)="getFinancialAccounts($event)"
  (rowActivated)="viewAccount($event)"
  [count]="totalElements"
  [loadingIndicator]="loading"
  [offset]="activePage"
  [footerHeight]="80"
  [messages]="{ emptyMessage: 'No Financial Accounts found.' }"
  emptyValuePlaceholder="--"
></rkt-table>
